import { BasketballEventStatusId } from '@collector/sportsapi-client-legacy'

export const eventStatuses: BasketballEventStatusId[] = [
  BasketballEventStatusId.NotStarted,
  BasketballEventStatusId.StartDelayed,
  BasketballEventStatusId.FirstQuarter,
  BasketballEventStatusId.SecondQuarter,
  BasketballEventStatusId.ThirdQuarter,
  BasketballEventStatusId.FourthQuarter,
  BasketballEventStatusId.FirstHalf,
  BasketballEventStatusId.SecondHalf,
  BasketballEventStatusId.BreakAfterFirstQuarter,
  BasketballEventStatusId.BreakAfterSecondQuarter,
  BasketballEventStatusId.BreakAfterThirdQuarter,
  BasketballEventStatusId.BreakAfterFirstHalf,
  BasketballEventStatusId.FinishedRegularTime,
  BasketballEventStatusId.WaitingForOvertime,
  BasketballEventStatusId.FirstOvertime,
  BasketballEventStatusId.SecondOvertime,
  BasketballEventStatusId.ThirdOvertime,
  BasketballEventStatusId.FourthOvertime,
  BasketballEventStatusId.FifthOvertime,
  BasketballEventStatusId.BreakAfterFirstOvertime,
  BasketballEventStatusId.BreakAfterSecondOvertime,
  BasketballEventStatusId.BreakAfterThirdOvertime,
  BasketballEventStatusId.BreakAfterFourthOvertime,
  BasketballEventStatusId.FinishedAfterOvertime,
  BasketballEventStatusId.FinishedAwardedWin,
  BasketballEventStatusId.Interrupted,
  BasketballEventStatusId.ToFinish,
  BasketballEventStatusId.Postponed,
  BasketballEventStatusId.Abandoned,
  BasketballEventStatusId.Cancelled,
]
